import { Component, OnInit, ElementRef, AfterViewInit, ViewChild, ChangeDetectionStrategy, Input, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { LanguageService, PlayerService, TemplateService, TicketService } from '../../_services';
import { Columns, APIDefinition, DefaultConfig, Config, Event, API } from 'ngx-easy-table';
import { NbWindowService } from '@nebular/theme';

import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';

interface EventObject {
  event: string;
  value: {
    limit: number;
    page: number;
  };
}
@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TableComponent implements OnInit {

  @ViewChild('table') table: APIDefinition;
  @ViewChild('input') input: ElementRef;

  searchInput='';
  data = []
  copyData = []
  
  @Input() scroll=true
  @Input() columns;
  @Input() page
  @Input() games = []
  @Input() activeSelection = false;
  @Input() set dataTable(model){
    if(model){
      this.data = [...model]
      this.copyData = [...model]
      this.setPagination();
      this.pagination = { ...this.pagination };
      if(this.searchInput) this.searchData(this.searchInput);
      this.cdr.markForCheck();
    }
  };
  @Input() set hits(model){
    if(model) this.setData(model)
  };
  _hitsDetails

  @Input() paginationActive = true;
  public pagination :{
    limit: Number,
    offset: Number,
    count: Number,
  };

  @Output() select: EventEmitter<object> = new EventEmitter<object>();
  @Output() searchDataVouchers: EventEmitter<object> = new EventEmitter<object>();

  public configuration: Config;
  
  constructor(public ticketService: TicketService,
    public templateService: TemplateService,
    public languageService: LanguageService,
    private windowService: NbWindowService,
    public playerService: PlayerService,
    private readonly cdr: ChangeDetectorRef) {
  }

  setPagination(){
    console.log('setPagination:'+this.paginationActive+' '+this.data.length);
    this.pagination = {
      limit: this.paginationActive ? 10 : this.data.length,
      offset: 0,
      count: this.data.length,
    };
  }

  setData(hitsDetails){
    this._hitsDetails = hitsDetails
    this.data = hitsDetails.hits
    this.copyData = hitsDetails.hits
    this.pagination = {
      limit: 50,
      offset: hitsDetails.page+1,
      count: hitsDetails.nbHits,
    };
    this.pagination = { ...this.pagination };
    this.cdr.markForCheck();
  }

  ngOnInit(){
    this.configuration = { ...DefaultConfig };
    this.configuration.isLoading = true;
    this.configuration.selectRow = true;
    this.configuration.tableLayout.striped = true;
    this.configuration.horizontalScroll = this.scroll;
    if(!this.paginationActive) {
      this.configuration.paginationRangeEnabled = false;
      this.configuration.paginationEnabled = false;
    }
  }

  ngAfterViewInit(){
    this.configuration.isLoading = false;
    this.cdr.markForCheck();
    /*fromEvent(this.input.nativeElement,'keyup')
    .pipe(
        filter(Boolean),
        debounceTime(150),
        distinctUntilChanged(),
        tap((text) => {
          console.log(this.input.nativeElement.value)
          this.searchData($event)
        })
    )
    .subscribe();*/
  }

  clearInput(){
    this.searchInput = ""
    this.data = this.copyData
    if(this._hitsDetails) this.searchDataVouchers.emit({input:''})
  }

  parseEvent(obj: EventObject): void {
    this.pagination.limit = this._hitsDetails ? 50 : 10;
    this.pagination.offset = obj.value.page ? obj.value.page : this.pagination.offset;
    if(this.searchInput.length == 0) this.searchDataVouchers.emit({input:'', pagination:this.pagination})
    else this.searchDataVouchers.emit({input:this.searchInput, pagination:this.pagination})
  }

  eventEmitted($event: { event: string; value: any }): void {
    //console.log('eventEmitted:'+$event.event);
    if($event.event === Event.onPagination){
      this.parseEvent($event);
    } 
    if($event.event === Event.onClick){
      if($event.value.key != 'checked' && this.activeSelection) this.select.emit($event.value.row)
    }
    if($event.event == Event.onOrder && $event.value.key == 'percentageAbandon'){
      this.orderByPercentageAbandon($event.value.order === 'asc')
    }
    else if($event.event == Event.onOrder) {
      let column = this.columns.find((column)=> column.key == $event.value.key)
      if(column.type == 'string') this.sortString($event.value.order, $event.value.key)
      if(column.type == 'map') this.sortMap($event.value.order, $event.value.key)
      if(column.type == 'number') this.sortNumber($event.value.order, $event.value.key)
      if(column.type == 'boolean') this.sortBoolean($event.value.order, $event.value.key)
      if(column.type == 'date') this.sortDate($event.value.order, $event.value.key)
    }
  }

  sortBoolean(sortType, att){
    //console.log('sortBoolean:'+sortType+' '+att);
    this.data = [...this.data].sort((a, b) =>{
      let aAtt = a[att] ? true : false
      let bAtt = b[att] ? true : false
      if('asc' == sortType) return Number(bAtt) - Number(aAtt)
      else return Number(aAtt) - Number(bAtt)
    })
  }

  orderByPercentageAbandon(asc: boolean): void {
    //console.log('orderByPercentageAbandon:'+asc);
    this.data = [
      ...this.data.sort((a, b) => {
        const nameA = a.getPercentageNotCompleted();
        const nameB = b.getPercentageNotCompleted();
        if (nameA < nameB) {
          return asc ? -1 : 1;
        }
        if (nameA > nameB) {
          return asc ? 1 : -1;
        }
        return 0;
      }),
    ];
  }

  sortNumber(sortType, att){
    console.log('sortNumber:'+sortType+' '+att);
    let aAtt,bAtt
    const assignValue = val => {
      if(val || val==0 ) return val;
      else {
        if('desc' == sortType) return -Infinity;
        else return Infinity;
      }
    };
    this.data = [...this.data.sort((a, b) => {
      if('teamCountTotal' == att){
        aAtt = a.teamCountTotal || a.teamCountTotal==0  ? a.teamCountTotal : a.teamCount
        bAtt = b.teamCountTotal || b.teamCountTotal==0 ? b.teamCountTotal : b.teamCount
      }else if('averageRating' == att || 'AverageDuration' == att || 'duration' == att ){
        aAtt = a[att] > 0 ? a[att] : null
        bAtt = b[att] > 0 ? b[att] : null
      }else if(att == 'gameUsage'){
        aAtt = a.gameUsage?.length
        bAtt = b.gameUsage?.length
      } else if('customRiddleCount' == att ){
        aAtt = (a.customRiddleCount ? a.customRiddleCount : 0)-(a.customRiddleVerifiedCount ? a.customRiddleVerifiedCount : 0)
        bAtt = (b.customRiddleCount ? b.customRiddleCount : 0)-(b.customRiddleVerifiedCount ? b.customRiddleVerifiedCount : 0)
      } else {
        console.log('att:'+att+' a[att]:'+a[att]+' b[att]:'+b[att]);
        aAtt = typeof a[att] == 'number'? a[att] : +a[att]
        bAtt = typeof b[att] == 'number'? b[att] : +b[att]
      }
      console.log('aAtt:'+aAtt+' bAtt:'+bAtt);
      if('desc' == sortType) return assignValue(bAtt) - assignValue(aAtt)
      else return assignValue(aAtt) - assignValue(bAtt);
    })]
  }

  sortMap(sortType, att){
    //console.log('sortMap:'+sortType+' '+att);
    this.data = [...this.data.sort((a, b) => {
      let aAtt,bAtt
      if(att == 'game.name'){
        aAtt = a.game.name[this.languageService.currentLang] ? a.game.name[this.languageService.currentLang]: null
        bAtt = b.game.name[this.languageService.currentLang] ? b.game.name[this.languageService.currentLang]: null
      }else {
        aAtt = a[att][this.languageService.currentLang] ? a[att][this.languageService.currentLang]: null
        bAtt = b[att][this.languageService.currentLang] ? b[att][this.languageService.currentLang]: null
      }
     
      if (bAtt === aAtt) return 0;
      if(aAtt == null || !aAtt) return 1;
      if(bAtt == null || !bAtt) return -1;

      if('asc' == sortType) return aAtt.localeCompare(bAtt);
      else return bAtt.localeCompare(aAtt);
    })]
  }

  sortString(sortType, att){
    //console.log('sortString:'+sortType+' '+att);
    this.data = [...this.data.sort((a, b) => {
      let aAtt,bAtt
      if(att == "templateId"){
        let aTemplate = this.getNameTemplate(a.templateId)
        let bTemplate = this.getNameTemplate(b.templateId)
        aAtt = aTemplate ? aTemplate: a.templateId
        bAtt = bTemplate ? bTemplate : b.templateId
      } else if(att == "name"){
        aAtt = a.name ? a.name : a.travelerName? a.travelerName : a.travelerName;
        bAtt = b.name ? b.name : b.travelerName? b.travelerName : b.travelerName;
      } else if(att == "refNumber"){
        aAtt = a.refNumber ? a.refNumber : a.bookingRef ? a.bookingRef : a.dbOrderId
        bAtt = b.refNumber ? b.refNumber : b.bookingRef ? b.bookingRef : b.dbOrderId
      } else if(att == "themeId"){
        aAtt = a.themeId || a.gameId
        bAtt = b.themeId || b.gameId
      } else if(att == "gameName"){
        aAtt = a?.items? (a?.items.length>0 ? a?.items[0].name : null) : null
        bAtt = b?.items? (b?.items.length>0 ? b?.items[0].name : null) : null
      } else if(att == "currentGame"){
        aAtt = this.getGame(a.gameId)?.name[this.languageService.currentLang]
        bAtt = this.getGame(b.gameId)?.name[this.languageService.currentLang]
      } else {
        aAtt = a[att]
        bAtt = b[att]
      }

      if (bAtt === aAtt) return 0;

      if(aAtt == null || !aAtt) return 1;

      if(bAtt == null || !bAtt) return -1;

      if(aAtt[0] ==' ') aAtt = aAtt.replace(/^\s+/g, '')
      if(bAtt[0] ==' ') bAtt = bAtt.replace(/^\s+/g, '')
    
      if('asc' == sortType) return aAtt.localeCompare(bAtt);
      else return bAtt.localeCompare(aAtt);
    })]
  }

  sortDate(sortType, att){
    console.log('sortDate:'+sortType+' '+att);
    this.data = [...this.data.sort((a, b) => {
      let aAtt = a[att] as Date;
      let bAtt = b[att] as Date;
      console.log('aAtt:'+aAtt+' bAtt:'+bAtt);
      if('asc' == sortType) return aAtt.getTime() - bAtt.getTime();
      else return bAtt.getTime() - aAtt.getTime();
    })]
  }

  getGame(gameId){
    //console.log('getGame:'+gameId);
    return this.games.filter(( game )=> {return game.id == gameId})[0];
  }

  getNameTemplate(templateId){
    //console.log('getNameTemplate:'+templateId);
    if(templateId){
      if(this.templateService.templates){
        let result = this.templateService.templates.filter(template => template.id == templateId)
        if(result[0]) return result[0].name[this.languageService.currentLang]
      }
    }else return;
  }

  searchData(event): void {
    let val =(event.target as HTMLInputElement) ? (event.target as HTMLInputElement).value.toLowerCase():event;
    //console.log('Search data:'+val);
    if(val.length == 0) this.data = this.copyData
    else{
      if(this._hitsDetails){
        if(event.key == "Enter") this.searchDataVouchers.emit({input:val})
      } else{
        let results = [];
        for (const element of this.copyData){
          for (const column of this.columns){
            const key = column.key;
            if(column.searchable){
              //console.log('column:'+column.type)
              if(column.type == 'map'){
                let found = false;
                for(let code of this.languageService.languagesCodes){
                  if(element[key] && element[key][code]){
                    if(element[key][code].toLowerCase().indexOf(val)!=-1) {
                      found = true;
                    }
                  }
                }
                if(found){
                  results.push(element);
                  break;
                }
              }
              if(key == 'refNumber'){
                if(element.bookingRef){
                  if(element.bookingRef.toLowerCase().indexOf(val)!=-1) {
                    results.push(element);
                    break;
                  }
                }
                if(element.refNumber){
                  if(element.refNumber.toLowerCase().indexOf(val)!=-1) {
                    results.push(element);
                    break;
                  }
                }
                if(element.dbOrderId){
                  if(element.dbOrderId.toLowerCase().indexOf(val)!=-1) {
                    results.push(element);
                    break;
                  }
                }
              }
              if(key == 'currentGame' && element.gameId){
                let nameGame = this.getGame(element.gameId)?.name
                if(nameGame && nameGame[this.languageService.currentLang]){
                  if(nameGame[this.languageService.currentLang].toLowerCase().indexOf(val)!=-1) {
                    results.push(element);
                    break;
                  }
                }
              }
              if(key == 'gameName'){
                let nameGame = element?.items? element?.items[0].name : null
                if(nameGame){
                  if(nameGame.toLowerCase().indexOf(val)!=-1) {
                    results.push(element);
                    break;
                  }
                }
              }
              if(key.toLowerCase().indexOf('game.name')!=-1){
                if(element.game.name[this.languageService.currentLang]){
                  if(element.game.name[this.languageService.currentLang].toLowerCase().indexOf(val)!=-1) {
                    results.push(element);
                    break;
                  }
                }
              }
              if(element[key] && element[key].toString().toLowerCase().indexOf(val)!=-1) {
                results.push(element);
                break;
              }
            }
          }
        }
        this.data = results;
        this.setPagination();
      }
    }
    //console.log('Search data END. Found:'+this.data.length);
  }

}